import { useEffect, useState, useCallback } from 'react';
import countUnreadNotifications from '../../../api/Notification/countUnreadNotifications';
import useClient from 'api/client';

export default function useCountNotifications() {
    const client = useClient() as unknown as {
        query: (query: any) => Promise<any>;
    };
    const [notifications, setNotifications] = useState<number>(0); // Assuming a default value of 0

    const fetchNotifications = useCallback(() => {
        if (client) {
            client.query(countUnreadNotifications()).then((response) => {
                setNotifications(response.data.countUnreadNotifications || 0);
            });
        }
    }, [client]);

    useEffect(() => {
        fetchNotifications();
    }, [fetchNotifications]);

    return { notifications, fetchNotifications };
}
